// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primeicons/primeicons.css'
import Vue3Marquee from 'vue3-marquee'

createApp(App).use(router).use(PrimeVue).use(Vue3Marquee).mount('#app');
